module.exports = __webpack_public_path__ + "static/media/ic_icon_1_85percentblack.e9e25846.svg";